
export default {
  name: 'ChangePercent',
  props: {
    change: {
      type: Number,
      required: true,
      default: 0,
    },
    precision: {
      type: Number,
      default: 2,
    },
    paddingX: {
      type: Number,
      default: 1,
    },
    // Allows us to ignore mobile decimal restriction when displaying change percent
    ignoreMobileDecimalRestriction: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: [String, null],
      required: false,
      default: null,
    },
    fontWeight: {
      type: [String, null],
      required: false,
      default: null,
    },
    leading: {
      type: [String, null],
      required: false,
      default: null,
    },
    height: {
      type: [String, null],
      required: false,
      default: null,
    },
    textColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    changeClass() {
      const colorClass = this.textColor
        ? this.textColor
        : this.change < 0
        ? 'change-negative'
        : 'change-positive';

      return `change-precent ${colorClass} ${this.fontSize ?? 'text-fs-1_5'} ${
        this.fontWeight ?? 'text-fw-3'
      } leading-${this.leading ?? '4'} h-${this.height ?? '4'}`;
    },
  },
};
